import { render } from "./AlgoliaSearch.vue?vue&type=template&id=07600f2c"
import script from "./AlgoliaSearch.vue?vue&type=script&lang=js"
export * from "./AlgoliaSearch.vue?vue&type=script&lang=js"

import "./AlgoliaSearch.vue?vue&type=style&index=0&id=07600f2c&lang=css"

import exportComponent from "/home/forge/princes-trust.ac.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__